import React from 'react'
import { PageTitle } from 'src/components/PageLayout/PageTitle'
import {
  IndexPageContainer,
  IndexPageContent,
  IndexPageHeader,
  IndexPageContentTabsContainer,
  IndexPageTabsContainer,
} from '../../PageLayout/PageLayout.styles'
import { GridContainer } from '../Grid'

type IndexPageProps = {
  title?: string
  headerTabs?: JSX.Element
  filterBar?: JSX.Element
  actions?: JSX.Element
  message?: JSX.Element
  indexGrid?: JSX.Element
  tabs?: JSX.Element
  pagination?: JSX.Element
  modals?: JSX.Element[]
  noTitleBorder?: boolean
}

export const IndexPage = ({
  title,
  actions,
  filterBar,
  message,
  indexGrid,
  tabs,
  pagination,
  modals,
  noTitleBorder,
}: IndexPageProps): JSX.Element => (
  <IndexPageContainer>
    <IndexPageHeader>
      {title && <PageTitle title={title} noBorder={noTitleBorder} />}
      {actions}
      {message}
      {filterBar}
    </IndexPageHeader>
    <IndexPageContent>
      {tabs && (
        <IndexPageContentTabsContainer>{tabs}</IndexPageContentTabsContainer>
      )}
      {indexGrid && <GridContainer>{indexGrid}</GridContainer>}
      {pagination}
    </IndexPageContent>
    <>{modals?.map((modal) => modal)}</>
  </IndexPageContainer>
)

export const IndexPageWithTabs = ({
  title,
  tabs,
}: {
  title: string
  tabs: JSX.Element
}): JSX.Element => (
  <IndexPageTabsContainer>
    <IndexPageHeader>{title && <PageTitle title={title} />}</IndexPageHeader>
    {tabs}
  </IndexPageTabsContainer>
)
